import React, { useState } from 'react'
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { motion } from 'framer-motion';
import { Button } from './Button';

export const OpenLineResponse = (props) => {

    const classes = useStyles();
    const { action, breakPoints: [ xs, sm, md, lg ] } = props;
    const [value, setValue] = useState('');

    return (    
        <div className={classes.main}>
            <Grid container justifyContent='center' alignItems='center'>
                <Grid item xs={ xs} sm={ sm } md={ md } lg={ lg }>
                    <motion.div 
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        className={ classes.containerInputText }
                    >
                        <input onChange={ (e) => setValue(e.target.value) } className={ classes.inputText } type="text" placeholder="Ingresa tu respuesta" />
                    </motion.div>

                    {
                        value && (
                            <Button
                                title='Continuar'
                                action={ () => action(value.toLowerCase().trim()) }
                                directionX='flex-end'
                                breakPoints={[6, 6, 5, 5]}
                            />
                        )
                    }
                </Grid>
            </Grid>
        </div>
    )
}

OpenLineResponse.defaultProps = {
    action: () => false,
    breakPoints: [10, 8, 6, 6]
}

const useStyles = makeStyles({
    main: {
        width: '100%',
        display: 'flex',
        flexFlow: 'column noWrap',
        alignItems: 'center',
        justifyContent: 'center'
    },
    containerInputText: {
        borderRadius: 4,
        padding: 10,
        background: '#fff',
        marginBottom: 15
    },

    inputText: {
        border: 'none',
        width: '100%',
        fontSize: 'clamp(.9rem, 5vw, 1rem)',

        '&:focus': {
            outline: 'none !important'
        }
    }
});